import GhostContentAPI from "@tryghost/content-api";

const api = new GhostContentAPI({
  url: process.env.REACT_APP_GHOST_URL || "https://bondpay.ghost.io",
  key:
    process.env.REACT_APP_GHOST_CONTENT_API_KEY || "ff7247197a7b12de9940f104c0",
  version: "v3.0",
});

export default api;
